import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";

// const AUTHBRIDGE_BASE_URL = "https://uat-video.authbridge.com/api";

interface CreateCaseParams {
  email: string;
  state: string;
  fullName: string;
  phone: string;
  value: string; // scheduled_time (IST formatted)
}

interface SessionResult {
  scheduled_time: string;
  created_at: string;
  status: string;
  case: number;
}

export const createCaseInitialization = async ({
  email,
  state,
  fullName,
  phone,
  value,
}: CreateCaseParams): Promise<SessionResult> => {
  const sessionId = getSessionId();

  try {
    /* =========================
       STEP 1: CREATE CASE
    ========================== */
    const caseResponse = await axios.post(
      `${process.env.REACT_APP_BASE_URL}authbridge/schedule-case/`,
      {
        jsonrpc: "2.0",
        method: "call",
        params: {
          payload: [
            {
              admin_comment: "",
              agent: 275,
              case_type: "video_kyc",
              client: 54,
              connection_detail: [
                {
                  email,
                  mobile_number: phone,
                  name: fullName,
                  participant_tag: "",
                },
              ],
              name: fullName,
              office_address: state,
              process: 61,
            },
          ],
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      },
    );

    // 🟢 Extract caseId from response
    // console.log(caseResponse);

    const caseId = caseResponse.data?.result?.data?.[0]?.[0]?.case_id || null;

    if (!caseId) {
      throw new Error("Case creation failed: caseId not returned.");
    }

    /* =========================
       STEP 2: CREATE SESSION
    ========================== */
    const sessionResponse = await axios.post(
      `${process.env.REACT_APP_BASE_URL}authbridge/schedule-session`,
      {
        jsonrpc: "2.0",
        method: "call",
        params: {
          case: caseId,
          scheduled_time: value,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      },
    );

    const sessionData = sessionResponse.data?.result?.data;

    if (!sessionData) {
      throw new Error("Session creation failed: invalid response");
    }

    /* =========================
       STEP 3: UPDATE CASE STATUS (PATCH)
    ========================== */
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}authbridge/update-case-status`,
      {
        jsonrpc: "2.0",
        method: "call",
        params: {
          case_id: caseId,
          status: "scheduled",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      },
    );

    // Return final session result
    const {
      scheduled_time,
      created_at,
      status,
      case: caseNumber,
    } = sessionData;

    return {
      scheduled_time,
      created_at,
      status,
      case: caseNumber,
    };
  } catch (error: any) {
    console.error(
      "❌ AuthBridge case/session initialization failed:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
